export const ACCOUNT_MODAL = 'ACCOUNT_MODAL';
export const DEFAULT_ACCOUNT_MODAL_CALLER_IDENTIFIER = 'AccountCreationForm';
